class Configuration {
  BASEURL=process.env.REACT_APP_BASEURL;
  defaultAuthorization=process.env.REACT_APP_default_Authorization;
  APP_BASE_URL=process.env.REACT_APP_BASE_URL;
  SIMULATE_URL=process.env.REACT_APP_SIMULATE_URL;
  ENV=process.env.REACT_APP_ENV;
}
export default Configuration;
